import { useMemo } from "react";
import PropTypes from "prop-types";
import { Box } from "@chakra-ui/react";
import { BACKGROUND_TYPES } from "./snapshotMaker.constants";

const getStyles = (type, value) => {
  const styles = {
    position: "absolute",
    inset: "0",
    zIndex: "-1",
  };

  switch (type) {
    case BACKGROUND_TYPES.color:
      styles.background = value;
      break;
    case BACKGROUND_TYPES.image:
      styles.backgroundImage = `url(${value})`;
      styles.backgroundRepeat = "no-repeat";
      styles.backgroundPosition = "center";
      styles.backgroundSize = "cover";
      break;
    case BACKGROUND_TYPES.gradient:
      styles.bgGradient = value;
      break;
    default:
      break;
  }

  return styles;
};

const SnapshotMakerBackground = ({ config = {} }) => {
  const styles = useMemo(() => getStyles(config.type, config.value), [config]);

  return (
    <Box sx={styles} />
  );
};

SnapshotMakerBackground.propTypes = {
  config: PropTypes.shape({
    type: PropTypes.oneOf(Object.values(BACKGROUND_TYPES)),
    value: PropTypes.string,
  }),
};

SnapshotMakerBackground.defaultProps = {
  config: undefined,
};

export default SnapshotMakerBackground;
